import React, { Component } from 'react'
import Dashboard from '../../components/Dashboard/Dashboard';

class DashboardRoute extends Component {
  render() {
    return (
        <Dashboard />
    );
  }
}

export default DashboardRoute
